
import { mapGetters, mapMutations, mapActions } from 'vuex'
export default {
  name: 'FilterToggle',
  props: {
    filterLabel: {
      type: String,
      required: true,
    },
    filterField: {
      type: String,
      required: true,
    },
    alignRight: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      buttonToggled: false,
    }
  },
  computed: {
    ...mapGetters({
      vxSearchFilters: 'search/getSearchFilters',
      vxStoryContent: 'search/getStoryContent',
    }),
    filterValue() {
      return `filter.${this.filterField}=1`
    },
  },
  watch: {
    vxSearchFilters: {
      handler() {
        this.buttonToggled = this.vxSearchFilters.includes(this.filterValue)
      },
      deep: true,
    },
  },
  mounted() {
    if (this.vxSearchFilters.includes(this.filterValue)) {
      this.buttonToggled = true
    }
  },
  methods: {
    toggleFilterButton() {
      if (this.buttonToggled) {
        this.buttonToggled = false
        this.vxSearchFilters.splice(
          this.vxSearchFilters.indexOf(this.filterValue),
          1
        )
        this.vxResetSearchResults('filtering')
        this.vxQuerySearchspring()
      } else {
        this.buttonToggled = true
        if (!this.vxSearchFilters.includes(this.filterValue)) {
          this.vxSearchFilters.push(this.filterValue)
        }
        this.vxResetSearchResults('filtering')
        this.vxQuerySearchspring()
      }
    },
    ...mapMutations({
      vxResetSearchResults: 'search/resetSearchResults',
      vxSetSearchFilters: 'search/setSearchFilters',
    }),
    ...mapActions({
      vxQuerySearchspring: 'search/querySearchspring',
    }),
  },
}
